import Resizer from 'react-image-file-resizer';

export const resizeFile = (file: File) =>
  file &&
  new Promise((resolve: (value: any) => void) => {
    Resizer.imageFileResizer(
      file,
      600,
      600,
      'PNG',
      70,
      0,
      (file) => {
        resolve(file);
      },
      'file'
    );
  });
